import { ManaSyringe } from '@antv/xflow-core';
/** 画布布局 */
export var LayoutEnum;
(function (LayoutEnum) {
    LayoutEnum["TOP_BOTTOM"] = "TB";
    LayoutEnum["LEFT_RIGHT"] = "LR";
})(LayoutEnum || (LayoutEnum = {}));
/** Props Config */
export const IComponentConfig = ManaSyringe.Syringe.defineToken('DAG_EXTENSION_CONFIG');
//# sourceMappingURL=interface.js.map